const LEGACY_FIELDS = new Set(["StatusId", "RoleId", "IsBGI", "IsFeePaid"]);

function parseIds(value) {
  if (!value) return [];
  return value
    .split(",")
    .map((x) => parseInt(x.trim(), 10))
    .filter((x) => !Number.isNaN(x));
}

function joinIds(ids) {
  return (ids || []).filter((x) => x != null && x !== "").join(",");
}

export function emptySurveyFilters() {
  return {
    organizationIds: [],
    sectionIds: [],
    rankIds: [],
    gender: "All",
    ageFrom: null,
    ageTo: null,
    _legacyRows: [],
  };
}

export function rowsToFilters(rows) {
  const result = emptySurveyFilters();

  (rows || []).forEach((row) => {
    const { fieldName, comparisonOperator, filterValue, id } = row;

    if (fieldName === "OrganizationId" && comparisonOperator === "IN") {
      result.organizationIds = parseIds(filterValue);
    } else if (fieldName === "OrganizationId" && comparisonOperator === "=") {
      const single = parseInt(filterValue, 10);
      if (!Number.isNaN(single)) result.organizationIds = [single];
    } else if (fieldName === "SectionId" && comparisonOperator === "IN") {
      result.sectionIds = parseIds(filterValue);
    } else if (fieldName === "SectionId" && comparisonOperator === "=") {
      const single = parseInt(filterValue, 10);
      if (!Number.isNaN(single)) result.sectionIds = [single];
    } else if (fieldName === "RankId" && comparisonOperator === "IN") {
      result.rankIds = parseIds(filterValue);
    } else if (fieldName === "RankId" && comparisonOperator === "=") {
      const single = parseInt(filterValue, 10);
      if (!Number.isNaN(single)) result.rankIds = [single];
    } else if (fieldName === "Gender" && comparisonOperator === "=") {
      result.gender = filterValue || "All";
    } else if (fieldName === "Age" && comparisonOperator === ">=") {
      result.ageFrom = filterValue !== "" && filterValue != null ? Number(filterValue) : null;
    } else if (fieldName === "Age" && comparisonOperator === "<=") {
      result.ageTo = filterValue !== "" && filterValue != null ? Number(filterValue) : null;
    } else if (LEGACY_FIELDS.has(fieldName) || fieldName === "Age") {
      result._legacyRows.push({
        id,
        fieldName,
        comparisonOperator,
        filterValue,
      });
    }
  });

  return result;
}

export function filtersToRows(structured) {
  const rows = [];

  if (structured._legacyRows?.length) {
    structured._legacyRows.forEach((row) => {
      rows.push({
        id: row.id ?? null,
        fieldName: row.fieldName,
        comparisonOperator: row.comparisonOperator,
        filterValue: row.filterValue,
      });
    });
  }

  if (structured.organizationIds?.length) {
    rows.push({
      id: null,
      fieldName: "OrganizationId",
      comparisonOperator: "IN",
      filterValue: joinIds(structured.organizationIds),
    });
  }

  if (structured.sectionIds?.length) {
    rows.push({
      id: null,
      fieldName: "SectionId",
      comparisonOperator: "IN",
      filterValue: joinIds(structured.sectionIds),
    });
  }

  if (structured.rankIds?.length) {
    rows.push({
      id: null,
      fieldName: "RankId",
      comparisonOperator: "IN",
      filterValue: joinIds(structured.rankIds),
    });
  }

  if (structured.gender && structured.gender !== "All") {
    rows.push({
      id: null,
      fieldName: "Gender",
      comparisonOperator: "=",
      filterValue: structured.gender,
    });
  }

  if (structured.ageFrom != null && structured.ageFrom !== "") {
    rows.push({
      id: null,
      fieldName: "Age",
      comparisonOperator: ">=",
      filterValue: String(structured.ageFrom),
    });
  }

  if (structured.ageTo != null && structured.ageTo !== "") {
    rows.push({
      id: null,
      fieldName: "Age",
      comparisonOperator: "<=",
      filterValue: String(structured.ageTo),
    });
  }

  return rows;
}

export function activeFilterCount(structured) {
  if (!structured) return 0;
  let count = 0;
  if (structured.organizationIds?.length) count++;
  if (structured.sectionIds?.length) count++;
  if (structured.rankIds?.length) count++;
  if (structured.gender && structured.gender !== "All") count++;
  if (structured.ageFrom != null && structured.ageFrom !== "") count++;
  if (structured.ageTo != null && structured.ageTo !== "") count++;
  count += structured._legacyRows?.length ?? 0;
  return count;
}
